<div class="game-search-modal">
  <div class="header">
    <div class="header-toolbar">
      <button mat-icon-button type="button" class="close-btn" (click)="close()" aria-label="Close">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="header-title">Search</div>
      <div class="header-spacer"></div>
    </div>

    <div class="search-block">
      <div class="search-input-wrap">
        <mat-icon class="search-icon">search</mat-icon>
        <input
          class="search-input"
          data-id="searchGameInput"
          type="text"
          placeholder="Search"
          [ngModel]="searchItemValue()"
          (ngModelChange)="onSearchInput($event)"
          autofocus />
        @if (searchItemValue()) {
          <button mat-icon-button type="button" class="clear-btn" (click)="clearInput()" aria-label="Clear">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>

      @if (!isLoading() && noResultsFound() && searchItemValue().trim().length > 0) {
        <div class="search-hints">
          <span class="no-result"><span class="bolded">No hits.</span> Check our top titles instead!</span>
        </div>
      }

      @if ((isLoading() || resolving()) && searchItemValue().trim().length > 0) {
        <div class="loading-list">
          <mat-spinner [diameter]="40"></mat-spinner>
        </div>
      }
    </div>
  </div>

  <div class="results-content" #resultsContainer (scroll)="onResultsScroll()">
    @if (searchItemValue().trim().length === 0) {
      <div class="description">
        <p>Search by:</p>
        <ul>
          @for (tip of tips; track tip.example) {
            <li>
              {{ tip.prefix }}
              <span (click)="setSearchTip(tip.example)">{{ tip.example }}</span>
            </li>
          }
        </ul>
      </div>
    }

    @if (searchQueryData()?.total > 0 && !noResultsFound()) {
      <div class="result-list">
        @for (game of searchQueryData()?.games; track game.id) {
          <button type="button" class="result-item" (click)="selectGame(game)">
            <img class="thumb" [src]="game.imageUrl" [alt]="game.name" [title]="game.name" />
            <div class="info-holder">
              <p class="game-name" [attr.data-id]="'gameName_' + game.name">{{ game.name }}</p>
              <p class="game-studio" [attr.data-id]="'studioName_' + game.studio">{{ game.studio }}</p>
            </div>
          </button>
        }
      </div>
    }

    @if (showInfinite() && searchQueryData()?.games?.length) {
      <div class="infinite-loading">
        @if (isLoading() || loadingMore()) {
          <mat-spinner [diameter]="28"></mat-spinner>
        }
      </div>
    }
  </div>
</div>
